let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g5RXm")).then(() => parcelRequire('8lQN4'));